/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdatePricingGroupDto
 */
export interface CreateUpdatePricingGroupDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePricingGroupDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdatePricingGroupDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the CreateUpdatePricingGroupDto interface.
 */
export function instanceOfCreateUpdatePricingGroupDto(value: object): value is CreateUpdatePricingGroupDto {
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function CreateUpdatePricingGroupDtoFromJSON(json: any): CreateUpdatePricingGroupDto {
    return CreateUpdatePricingGroupDtoFromJSONTyped(json, false);
}

export function CreateUpdatePricingGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdatePricingGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'],
    };
}

export function CreateUpdatePricingGroupDtoToJSON(value?: CreateUpdatePricingGroupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'active': value['active'],
    };
}

